var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 93,
    viewBox: "0 0 71 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5219",
    "data-name": "Group 5219",
    transform: "translate(-1283.001 -3053.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4575",
    "data-name": "Group 4575",
    transform: "translate(124 -41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6065",
    "data-name": "Path 6065",
    d: "M2109.964,159.294a.684.684,0,0,0,.34-.552c0-.431-.517-.78-1.155-.78H2103.9c-.638,0-1.155.349-1.155.78a.713.713,0,0,0,.408.594l-.7,20.757-1.107,32.976c0,3.733,10.522,4.274,10.522.541C2111.866,213.609,2109.969,159.322,2109.964,159.294Z",
    transform: "translate(-895.014 2937.734)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M1948.313,280.007a.683.683,0,0,0,.34-.552c0-.431-.517-.78-1.155-.78h-5.254c-.637,0-1.154.349-1.154.78a.713.713,0,0,0,.407.594l-.7,20.757-.669,19.916h9.608C1949.177,304.639,1948.316,280.026,1948.313,280.007Z",
    transform: "translate(-753.083 2831.459)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6067",
    "data-name": "Path 6067",
    d: "M1730.72,528.4V509.329h27.546V496.673h33.693v12.656h3.177V528.4Z",
    transform: "translate(-570.719 2639.535)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4185",
    "data-name": "Group 4185",
    transform: "translate(1164.746 3157.154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3262",
    "data-name": "Rectangle 3262",
    width: 4.386,
    height: 3.872,
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3263",
    "data-name": "Rectangle 3263",
    width: 4.386,
    height: 3.872,
    transform: "translate(8.253)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3264",
    "data-name": "Rectangle 3264",
    width: 4.386,
    height: 3.872,
    transform: "translate(16.505)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3265",
    "data-name": "Rectangle 3265",
    width: 4.386,
    height: 3.872,
    transform: "translate(24.758)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3266",
    "data-name": "Rectangle 3266",
    width: 4.385,
    height: 3.872,
    transform: "translate(33.011)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3267",
    "data-name": "Rectangle 3267",
    width: 4.385,
    height: 3.872,
    transform: "translate(41.264)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3268",
    "data-name": "Rectangle 3268",
    width: 4.385,
    height: 3.872,
    transform: "translate(49.516)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4186",
    "data-name": "Group 4186",
    transform: "translate(1193.679 3143.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3269",
    "data-name": "Rectangle 3269",
    width: 4.386,
    height: 3.872,
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3270",
    "data-name": "Rectangle 3270",
    width: 4.385,
    height: 3.872,
    transform: "translate(8.253)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3271",
    "data-name": "Rectangle 3271",
    width: 4.386,
    height: 3.872,
    transform: "translate(16.505)",
    fill: "#ebebe8",
    stroke: "#313830",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.dc635ed790452db6fa0e4f6eed0b368c.svg";
export { ForwardRef as ReactComponent };